export default[
    {
    seriesImage:"./series-images/bad.webp",
    seriesName: 'Breaking Bad',
    yearOfRelease: 2008,
    seasons: 5
  },
  {
    seriesImage:"./series-images/avatar.jpg",
    seriesName: 'Avatar: The Last Airbender',
    yearOfRelease: 2005,
    seasons: 3
  },
  {
    seriesImage:"./series-images/planet.jpg",
    seriesName: 'Our Planet',
    yearOfRelease: 2019,
    seasons: 1
  },
  {
    seriesImage:"./series-images/kota.jpg",
    seriesName: 'Kota Factory',
    yearOfRelease: 2019,
    seasons: 2
  },
  {
    seriesImage:"./series-images/dance.jpg",
    seriesName: 'The Last Dance',
    yearOfRelease: 2020,
    seasons: 1
  },
  {
    seriesImage:"./series-images/arcane.jpg",
    seriesName: 'Arcane',
    yearOfRelease: 2021,
    seasons: 1
  },
  {
    seriesImage:"./series-images/aot.jpg",
    seriesName: 'Attack on Titan',
    yearOfRelease: 2013,
    seasons: 4
  },

  {
    seriesImage:"./series-images/note.jpg",
    seriesName: 'DEATH NOTE',
    yearOfRelease: 2006,
    seasons: 1
  },
  {
    seriesImage:"./series-images/seinfeld.jpg",
    seriesName: 'Seinfeld',
    yearOfRelease: 1989,
    seasons: 9
  },
  {
    seriesImage:"./series-images/avatar.jpg",
    seriesName: 'Avatar: The Last Airbender',
    yearOfRelease: 2005,
    seasons: 3
  },
  {
    seriesImage:"./series-images/planet.jpg",
    seriesName: 'Our Planet',
    yearOfRelease: 2019,
    seasons: 1
  },{
    seriesImage:"./series-images/bad.webp",
    seriesName: 'Breaking Bad',
    yearOfRelease: 2008,
    seasons: 5
  },
  {
    seriesImage:"./series-images/kota.jpg",
    seriesName: 'Kota Factory',
    yearOfRelease: 2019,
    seasons: 2
  },
  {
    seriesImage:"./series-images/dance.jpg",
    seriesName: 'The Last Dance',
    yearOfRelease: 2020,
    seasons: 1
  }
];